const SITE_URL = "https://www.tablemountain.net";

// items: [{ name, path }] in order, Home first. Never call this for the homepage itself —
// a single-item trail isn't a breadcrumb.
export function buildBreadcrumbSchema(items = []) {
  if (items.length < 2) return null;

  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((item, index) => ({
      "@type": "ListItem",
      position: index + 1,
      name: item.name,
      item: `${SITE_URL}${item.path}`,
    })),
  };
}
